export const normalizeDateInput = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
  const day = digits.slice(0, 2);
  let month = digits.slice(2, 4);
  if (month.length === 2) {
    const mNum = Number(month);
    if (mNum > 12) month = "12";
    if (mNum === 0) month = "01";
  }
  const year = digits.slice(4, 8);
  let out = day;
  if (month) out += `/${month}`;
  if (year) out += `/${year}`;
  return out;
};

export const toDateInputValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    const dm = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dm) return `${dm[1]}/${dm[2]}/${dm[3]}`;
    const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const formatDisplayDate = (value) => {
  if (!value) return "-";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return "-";
    const dm = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dm) return `${dm[1]}/${dm[2]}/${dm[3]}`;
    const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
    const d = new Date(trimmed);
    if (!Number.isNaN(d.getTime())) return d.toLocaleDateString("en-GB");
    return trimmed;
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-GB");
};

const getDateParts = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const trimmed = value.trim();
    const dm = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dm) return { dd: Number(dm[1]), mm: Number(dm[2]), yyyy: Number(dm[3]) };
    const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return { dd: Number(iso[3]), mm: Number(iso[2]), yyyy: Number(iso[1]) };
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return { dd: d.getDate(), mm: d.getMonth() + 1, yyyy: d.getFullYear() };
};

export const toSortableDate = (value) => {
  const parts = getDateParts(value);
  if (!parts) return null;
  const dd = String(parts.dd).padStart(2, "0");
  const mm = String(parts.mm).padStart(2, "0");
  const yyyy = String(parts.yyyy).padStart(4, "0");
  return Number(`${yyyy}${mm}${dd}`);
};

export const toDateObject = (value) => {
  const parts = getDateParts(value);
  if (!parts) return null;
  return new Date(parts.yyyy, parts.mm - 1, parts.dd);
};
